import { render, staticRenderFns } from "./PaymentsCosts.vue?vue&type=template&id=f3dd226c&scoped=true"
import script from "./PaymentsCosts.vue?vue&type=script&lang=js"
export * from "./PaymentsCosts.vue?vue&type=script&lang=js"
import style0 from "./PaymentsCosts.vue?vue&type=style&index=0&id=f3dd226c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3dd226c",
  null
  
)

export default component.exports